// Alphabetically ordered
export enum EmailProvider {
  Gmail = 'gmail',
  Outlook = 'outlook',
}
